import { addError } from '@shared/utils/logger';
import { useGetRegistryEventTaxDestinationQuery } from './useRegistryEventTaxDestination.graphql.generated';

export const useRegistryEventTaxDestination = (eventId: string | undefined) => {
  const { data, loading, error } = useGetRegistryEventTaxDestinationQuery({
    variables: { input: { eventId: eventId ?? '' } },
    skip: !eventId,
    ssr: false,
    batchMode: 'fast',
    // A failed lookup is indistinguishable from a non-taxable destination downstream — both
    // suppress gift wrap. Log here so a backend regression that hides gift wrap for every
    // taxable event is visible, rather than looking like correct fail-closed behavior.
    onError: error => addError(error, { context: 'useRegistryEventTaxDestination', eventId }),
  });

  return {
    registryEventTaxDestination: data?.registryEventTaxDestination,
    loading,
    error,
  };
};
